import { useState } from 'react'

// Hooks
import { useModal, useProject } from 'Hooks/'

// Components
import { ButtonsModal } from 'Organisms'
import TableBudgets from './TableBudgets'
import TableLogHistory from './TableLogHistory'
import { Bank } from '@phosphor-icons/react'
import { COLOR_WHITE } from 'constant/colors'

const FORM_CONTROL = 'addBudgetToTask'

const TABS_OPTIONS = [
  {
    name: 'Management'
  },
  {
    name: 'Log History'
  }
]

const ModalAddBudgetToTask = ({ visible, setVisible, budgetSettings, budgets, idProject, refreshProjectInfo }) => {
  const { Modal, hide } = useModal({ identifier: 'modalAddBudgetToTask', visible, setVisible })
  const { loadingProjectHook, addBudgetToTaskPerProjectHook } = useProject()

  const [addBudgetList, setAddBudgetList] = useState([])
  const [activeTab, setActiveTab] = useState(TABS_OPTIONS[0].name)

  const handleAddBudget = ({ idTask, budget }) => {
    if (addBudgetList.some((item) => item.id === idTask)) {
      return setAddBudgetList(
        addBudgetList.map((item) => {
          if (item.id === idTask) {
            return {
              ...item,
              budget
            }
          }

          return item
        })
      )
    }

    setAddBudgetList([...addBudgetList, { id: idTask, budget }])
  }

  const onSubmit = async (e) => {
    e.preventDefault()

    await Promise.allSettled(
      addBudgetList.map((item) =>
        addBudgetToTaskPerProjectHook({ idProject, idTask: item.id, newBudget: item.budget })
      )
    )

    await refreshProjectInfo()
    hide()
  }

  return (
    <Modal>
      <div className="modal-content" style={{ maxWidth: 1100 }}>
        <div className="modal-header align-items-start">
          <div className='col-auto'>
            <h3 className="modal-title fs-5 text-capitalize" id="exampleModalLabel">
              <Bank className="icon" size={20} color={COLOR_WHITE} weight="bold" style={{ position: 'relative', top: '-2px' }}/> <span>Manage budget</span>
            </h3>
            <p className='mb-0'>Keep track of your spending by setting up your project&apos;s budget.</p>
          </div>
          <button type="button" className="btn-close" onClick={() => hide()} aria-label="Close"></button>
        </div>
        <div className="modal-body">
          <div className="container-fluid">
            <div className='row my-4'>
              <div className='col-auto'>
                <ul className="nav nav-pills mb-4">
                  { TABS_OPTIONS.map((item, i) => (
                    <li key={i} className="nav-item">
                      <a className={`nav-link ${activeTab === item.name ? 'active' : ''}`} onClick={() => setActiveTab(item.name)} aria-current="page" href="#">{item.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col">
                <div className="row justify-content-center">
                  { activeTab === 'Management' &&
                    <form id={FORM_CONTROL} className="d-grid" onSubmit={onSubmit}>
                      <TableBudgets budgetSettings={budgetSettings} budgets={budgets} onAddBudget={handleAddBudget} />
                    </form>
                  }
                  { activeTab === 'Log History' && <TableLogHistory/> }
                </div>
              </div>
            </div>
            { activeTab === 'Management' &&
              <ButtonsModal onClose={hide} loading={loadingProjectHook} formControl={FORM_CONTROL} />
            }
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalAddBudgetToTask
